export const getCustomCondition = (condition) => {
  if (condition.operation === 'is duplicate') {
    return ['duplicate', true];
  }
  return [];
};
